import React from "react";
import styles from "./PieChart.module.sass";
import Highcharts from "highcharts/highstock";
import Chart from "highcharts-react-official";
import { useGlobalValue } from "../../../state/GlobalProvider";
import { getPropertyValue, hydrateRoute } from "../../../utils";
import Format from "../../Format";

const createColors = base => {
  let colors = [],
      i;

  for (i = 0; i < 11; i += 1) {
    colors.push(Highcharts.Color(base).brighten(i / 24).get());
  }

  return colors;
};

const truncateString = value => {
  let truncateString;

  if ((value ? value : "").length > 20) {
    truncateString = value.substring(value, 20) + "...";
  } else {
    truncateString = value;
  }

  return truncateString;
};

const renderOptions = (serie, link, chartColor, currencyType = {}) => {
  const {
    params,
    theme
  } = useGlobalValue();
  const {
    colors = {}
  } = theme || {};
  const {
    localeCurrency,
    currency
  } = currencyType;
  const chartColors = [getPropertyValue("--chart-primary-color").trim()];
  return {
    chart: {
      type: "pie",
      backgroundColor: null
    },
    credits: {
      enabled: false
    },
    title: {
      text: ""
    },
    plotOptions: {
      pie: {
        colors: createColors(chartColor ? chartColor : chartColors[0]),
        point: {
          events: {
            mouseOver: function () {
              if (!this.options.key) {
                return;
              }

              this.graphic.element.style.cursor = "pointer";
            },
            click: function () {
              if (!this.options.key) {
                return;
              }

              window.location.href = hydrateRoute(link, params) + this.options.key;
            },
            legendItemClick: function () {
              this.slice(null);
              return false;
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function () {
            return truncateString(this.key) + " <span />: " + Math.round(this.point.x * 100) / 100 + "%";
          }
        },
        size: 280
      }
    },
    tooltip: {
      backgroundColor: getPropertyValue("--pie-tooltip--background-color").trim(),
      style: {
        color: "white"
      },
      useHTML: true,
      formatter: function () {
        return this.key + " <br />" + Format({
          value: this.y,
          compact: "short",
          currency: currency,
          locale: localeCurrency
        });
      }
    },
    series: [{
      data: serie
    }],
    responsive: {
      rules: [{
        condition: {
          minWidth: 476
        },
        chartOptions: {
          chart: {
            marginTop: 50
          },
          plotOptions: {
            pie: {
              size: 280
            }
          }
        }
      }, {
        condition: {
          maxWidth: 475
        },
        chartOptions: {
          chart: {
            marginTop: -50
          },
          plotOptions: {
            pie: {
              size: 230
            }
          }
        }
      }, {
        condition: {
          maxWidth: 420
        },
        chartOptions: {
          chart: {
            marginTop: -80
          },
          plotOptions: {
            pie: {
              size: 210
            }
          }
        }
      }, {
        condition: {
          maxWidth: 385
        },
        chartOptions: {
          chart: {
            marginTop: -100
          },
          plotOptions: {
            pie: {
              size: 180
            }
          }
        }
      }, {
        condition: {
          maxWidth: 345
        },
        chartOptions: {
          chart: {
            marginTop: -120
          },
          plotOptions: {
            pie: {
              size: 150
            }
          }
        }
      }]
    }
  };
};

const PieChart = ({
  className,
  data,
  link,
  chartColor,
  currencyType
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["root"] || ""} ${className || ""}`
  }, data && /*#__PURE__*/React.createElement(Chart, {
    highcharts: Highcharts,
    options: renderOptions(data, link, chartColor, currencyType)
  }));
};

export default PieChart;